import area from './area';
import bar from './bar';
import barHorizontal from './bar-horizontal';
import line from './line';
import pie from './pie';
import radar from './radar';
import scatter from './scatter';
import timeline from './timeline';
var specs = {
    bar: bar,
    'bar-horizontal': barHorizontal,
    line: line,
    area: area,
    pie: pie,
    radar: radar,
    scatter: scatter,
    timeline: timeline
};
export default specs;
//# sourceMappingURL=specs.js.map